module.exports = __webpack_public_path__ + "img/dycardark.e7d9a6ad.webp";